import µ from "../earth/1.0.0/micro";
import {useCallback, useEffect} from "react";
import _ from "underscore";
import staticVariable from "./staticVariable";

const VariableControl = ({ isMobile, earthController, menuDisplayToggle, rightMenuToggle, setRightMenuToggle, setClearMouseModeAction, levelValue, setLevelValue ,overlayType, setOverlayType, setMouseMode }) => {

    const handleRightMenuClick = (menuType) => (e) => {
        if (rightMenuToggle === 'none') setRightMenuToggle(menuType); //오른쪽 메뉴가 없는 경우
        else if (rightMenuToggle !== menuType) setRightMenuToggle(menuType); //오른쪽 메뉴가 이미 컬러나 설정중 하나가 팝업 되어 있는 경우
        else setRightMenuToggle('none'); //팝업된 오른쪽 메뉴를 한번 더 누른경우
    }

    const handleClickOverlay = (clickedOverlay) => (e) => {
        const newAttr = {};
        newAttr.surface = "surface";
        newAttr.level = "level";
        newAttr.overlayType = clickedOverlay;
        if (clickedOverlay === "currents"
            ||clickedOverlay === "salnt"
            || clickedOverlay === "slr"
            || clickedOverlay === "sst"
            || clickedOverlay === "sea_ice_area")
            newAttr.param = "ocean";
        else
            newAttr.param = "wind";

        earthController.clearLocationDetailsAreaMean(true);
        earthController.clearLocationDetailsCrossSection(true);
        earthController.clearAvgAnnualLocationDetails(true);
        setOverlayType(clickedOverlay);
        setLevelValue(0);
        earthController.configuration.save(newAttr);
        µ.clearWorkerLocalStorage();
        setClearMouseModeAction(true);
        setMouseMode('basic');
        earthController.configuration.save({ crossSectionMode: false });
        earthController.configuration.save({ areaMeanMode: false });
    }

    const handleChangeSlider = (e) => {
        earthController.clearLocationDetailsAreaMean(true);
        earthController.clearAvgAnnualLocationDetails(true);
        earthController.clearLocationDetailsCrossSection(true);
        const overlayType = earthController.configuration.get("overlayType") === "default" ? earthController.configuration.get("param") === 'ocean' ? "currents" : 'wind'
            : earthController.configuration.get("overlayType");
        if (overlayType === 'wind' || overlayType === 'temp') {
            setLevelValue(Number(e.target.dataset.level));
            handleChangeLevel(Number(e.target.dataset.level));
        }
        µ.clearWorkerLocalStorage();
        setClearMouseModeAction(true);
    }

    //altitude가 변경되었을때 configuration을 변경시키기 위한 함수
    //debounce를 사용하기 위해 usecallback함수로 뺌
    const handleChangeLevel = useCallback(_.debounce(function (value) {
            var id = staticVariable.LEVEL_LIST[value.toString()];
            if (id !== undefined) {
                var parts = id.split("-");
                earthController.configuration.save({param: "wind", surface: parts[0], level: parts[1]});
            }
        }, 300)
        , [earthController]);

    //최초 렌더링할때 사이드이펙트
    useEffect(() => {
        if (earthController.configuration) {
            //최초 고도 세팅
            const level = earthController.configuration.get("level");
            if (!(level === 'level' || level === 'currents')) {
                const levelIndex = Object.keys(staticVariable.LEVEL_LIST).find(key => staticVariable.LEVEL_LIST[key] === `isobaric-${level}`);
                setLevelValue(Number(levelIndex));
            }

            //최초 오버레이 설정
            const configurationOverlay = earthController.configuration.get("overlayType") === "default" ? earthController.configuration.get("param") === 'ocean' ? "currents" : 'wind'
                : earthController.configuration.get("overlayType");
            setOverlayType(configurationOverlay);
        } // if (earthController.configuration) { end
    }, [earthController])

    return <>
        <div className="mrt01" style={menuDisplayToggle === true ? null : {display: 'none'}}>
            <div className="dv_btn01">
                <a href="javascript:;" className={(overlayType === "currents" ? "on" : "off") + " mrt_btn mrt_btn01"}
                   onClick={handleClickOverlay("currents")}>
                    <div className="w1">해류</div>
                </a>
            </div>
            <div className="dv_btn02">
                <a href="javascript:;"
                   className={(overlayType === "sea_ice_area" ? "on" : "off") + " mrt_btn mrt_btn02"}
                   onClick={handleClickOverlay("sea_ice_area")}>
                    <div className="w1">해빙</div>
                </a>
            </div>
            <div className="dv_btn03">
                <a href="javascript:;"
                   className={(overlayType === "total_precipitable_water" ? "on" : "off") + " mrt_btn mrt_btn03"}
                   onClick={handleClickOverlay("total_precipitable_water")}>
                    <div className="w1">강수</div>
                </a>
            </div>
            <div className="dv_btn03">
                <a href="javascript:;" className={(overlayType === "od550aer" ? "on" : "off") + " mrt_btn mrt_btn10"}
                   onClick={handleClickOverlay("od550aer")}>
                    <div className="w1">미세먼지</div>
                </a>
            </div>
            {/*아래 엘리먼트는 레이아웃을 맞추기 위한 엘리먼트임, 실제 기능은 없음!
           기존에는 mrt01가 변수 전체를 감싸고 있는 형태였지만 그렇게 할 경우 mrt01의 직사각형 범위만큼 canvas동작이 안됨(클릭,드래그 등)
           그래서 mrt01을 가로와 세로로 나누어 변수아이콘 공간만큼만 mrt01이 차지하도록 하기 위해 mrt01을 나누었다.
        */}
            <div className="dv_btn03" style={{visibility: 'hidden', paddingLeft: '8px'}}>
                <a className="mrt_btn mrt_btn03"><span className="blind">레이아웃용</span></a>
            </div>
        </div>
        {/*두번째 줄 아이콘들*/}
        <div className="mrt01 mrt02" style={menuDisplayToggle === true ? null : {display: 'none'}}>
            <div className="dv_btn01">
                <a href="javascript:;" className={(overlayType === "salnt" ? "on" : "off") + " mrt_btn mrt_btn09"}
                   onClick={handleClickOverlay("salnt")}>
                    <div className="w1">염분</div>
                </a>
            </div>
            <div className="dv_btn02">
                <a href="javascript:;"
                   className={(overlayType === "sst" ? "on" : "off") + " mrt_btn mrt_btn08"}
                   onClick={handleClickOverlay("sst")}>
                    <div className="w1">해수온도</div>
                </a>
            </div>
            <div className="dv_btn03">
                <a href="javascript:;"
                   className={(overlayType === "slr" ? "on" : "off") + " mrt_btn mrt_btn11"}
                   onClick={handleClickOverlay("slr")}>
                    <div className="w1">해수높이</div>
                </a>
            </div>
            {/*아래 엘리먼트는 레이아웃을 맞추기 위한 엘리먼트임, 실제 기능은 없음!
           기존에는 mrt01가 변수 전체를 감싸고 있는 형태였지만 그렇게 할 경우 mrt01의 직사각형 범위만큼 canvas동작이 안됨(클릭,드래그 등)
           그래서 mrt01을 가로와 세로로 나누어 변수아이콘 공간만큼만 mrt01이 차지하도록 하기 위해 mrt01을 나누었다.
        */}
            <div className="dv_btn03" style={{visibility: 'hidden', paddingLeft: '8px'}}>
                <a className="mrt_btn mrt_btn03"><span className="blind">레이아웃용</span></a>
            </div>
        </div>
        <div className="mrt01" style={menuDisplayToggle === true ? null : {display: 'none'}}>
            <div className="dv_rt01">
                <div className="dv_rt01_in01">
                    <div className="dv_btn04">
                        <a href="javascript:;" className={(overlayType === "wind" ? "on" : "off") + " mrt_btn mrt_btn04"} onClick={handleClickOverlay("wind")}><div className="w1">바람</div></a>
                    </div>
                    <div className="dv_btn05">
                        <a href="javascript:;" className={(overlayType === "temp" ? "on" : "off") + " mrt_btn mrt_btn05"} onClick={handleClickOverlay("temp")}><div className="w1">온도</div></a>
                    </div>
                    <div className="sq01">
                        <ul>
                            <li>
                                <a href="javascript:;" className={levelValue > 3 ? 'on' : 'off'} onClick={handleChangeSlider} data-level={4}>
                                    <span data-level={4}></span>
                                </a>
                                <div className="w1">10hPa</div>
                            </li>
                            <li>
                                <a href="javascript:;" className={levelValue > 2 ? 'on' : 'off'} onClick={handleChangeSlider} data-level={3}>
                                    <span data-level={3}></span>
                                </a>
                                <div className="w1">70hPa</div>
                            </li>
                            <li>
                                <a href="javascript:;" className={levelValue > 1 ? 'on' : 'off'} onClick={handleChangeSlider} data-level={2}>
                                    <span data-level={2}></span>
                                </a>
                                <div className="w1">250hPa</div>
                            </li>
                            <li>
                                <a href="javascript:;" className={levelValue > 0 ? 'on' : 'off'} onClick={handleChangeSlider} data-level={1}>
                                    <span data-level={1}></span>
                                </a>
                                <div className="w1">500hPa</div>
                            </li>
                            <li>
                                <a href="javascript:;" className={'on'} onClick={handleChangeSlider} data-level={0}>
                                    <span data-level={0}></span>
                                </a>
                                <div className="w1">Surface</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="dv_btn06">
                    <a href="javascript:;" className={(rightMenuToggle === 'configuration' ? "on" : "off") + " mrt_btn mrt_btn06"}><span
                        className="blind mrt_btn mrt_btn06" onClick={handleRightMenuClick('configuration')}>메뉴</span></a>
                </div>
                {isMobile ? null : <div className="sq02">
                    <div className="sq02_in" onClick={handleRightMenuClick('colorScale')}>
                        <a href="javascript:;"><span><canvas id="scale"></canvas></span>
                        </a>
                    </div>
                </div>}
            </div>
        </div>
    </>
}

export default VariableControl;